module.exports = __webpack_public_path__ + "img/body-blood-sugar.b8c806b.svg";